import { FieldKey } from '../../context/field-keys.js';
/**
 * Space-terms rate × size amounts, ported from the LIVE binder
 * `projects/miq/auto-calculation/src/lib/listeners/space-terms.binder.ts`
 * (`calculateAskingRentAmount` ~line 406, `calculateAchievableRentAmount` ~line 506):
 *
 *   askingRentAmount     = askingRate     × availableSpace
 *   achievableRentAmount = achievableRate × availableSpace
 *
 * Byte-parity notes (do NOT change):
 *  - The binder writes the RAW product — NO rounding ("asking/achievable write the RAW product
 *    exactly as the host"), so `deps.round` is intentionally not used here.
 *  - Guards match the binder: a missing/falsy/non-positive rate clears the amount to null, then a
 *    missing/falsy/non-positive size clears it to null (`!rate || rate <= 0`, `!size || size <= 0`).
 * Host-owned, NOT modelled: dirty/touched gating and the amount-UOM auto-select from the catalog
 * (`autoSelectFirstUOMOption`) plus the null-UOM clearing that accompanies a cleared amount (T2.7).
 */
/** Asking rent amount = asking rental rate × available space (raw, unrounded). */
export const askingRentAmountRule = {
  id: 'space.asking-rent-amount.from-rate-size',
  inputs: [FieldKey.SpaceAskingRentalRate, FieldKey.SpaceAvailableSpace],
  outputs: [FieldKey.SpaceAskingRentAmount],
  formulaVersion: '1.0.0',
  run: ctx => {
    const rate = Number(ctx.get(FieldKey.SpaceAskingRentalRate));
    if (!rate || rate <= 0) {
      ctx.set(FieldKey.SpaceAskingRentAmount, null);
      return;
    }
    const size = Number(ctx.get(FieldKey.SpaceAvailableSpace));
    if (!size || size <= 0) {
      ctx.set(FieldKey.SpaceAskingRentAmount, null);
      return;
    }
    ctx.set(FieldKey.SpaceAskingRentAmount, rate * size);
  }
};
/** Achievable rent amount = achievable rent (rate) × available space (raw, unrounded). */
export const achievableRentAmountRule = {
  id: 'space.achievable-rent-amount.from-rate-size',
  inputs: [FieldKey.SpaceAchievableRent, FieldKey.SpaceAvailableSpace],
  outputs: [FieldKey.SpaceAchievableRentAmount],
  formulaVersion: '1.0.0',
  run: ctx => {
    const rate = Number(ctx.get(FieldKey.SpaceAchievableRent));
    if (!rate || rate <= 0) {
      ctx.set(FieldKey.SpaceAchievableRentAmount, null);
      return;
    }
    const size = Number(ctx.get(FieldKey.SpaceAvailableSpace));
    if (!size || size <= 0) {
      ctx.set(FieldKey.SpaceAchievableRentAmount, null);
      return;
    }
    ctx.set(FieldKey.SpaceAchievableRentAmount, rate * size);
  }
};
export const spaceRentAmountRules = [askingRentAmountRule, achievableRentAmountRule];
